import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { Transition, UIRouterModule } from '@uirouter/angular';
import { CategoriesService } from '../shared/category/categories.service';
import { LoggingService } from '../shared/services/logging/logging.service';
import * as fromTimecard from '../timecard';
import { TimeCardModule } from '../timecard/time-card.module';
import { processResolver } from './process-resolver';
const log = new LoggingService();

// TODO: split these into areas

@NgModule({
    imports: [
        CommonModule,
        TimeCardModule,
        UIRouterModule.forChild({
            // TODO: will having all these here mess with lazy loading of modules?
            // https://ui-router.github.io/guide/lazyloading
            states: [
                {
                    name: 'timecard',
                    url: '/timecard',
                    data: { requiresAuth: true },
                    params: { process: {} },
                    resolve: [
                        {
                            token: 'process',
                            deps: [Transition, CategoriesService],
                            resolveFn: processResolver
                        }
                    ],
                    component: fromTimecard.TimeCardFeatureComponent
                },
                {
                    name: 'timecard.entry',
                    url: '/entry',
                    component: fromTimecard.TimeCardFeatureComponent
                },
                {
                    name: 'timecard.super',
                    url: '/super',
                    component: fromTimecard.TimeCardFeatureComponent
                },
                {
                    name: 'timecard.validate',
                    url: '/validate',
                    component: fromTimecard.TimeCardFeatureComponent
                },
                {
                    name: 'timecard.approval',
                    url: '/approve',
                    component: fromTimecard.TimeCardFeatureComponent
                },
                {
                    name: 'timecarddoc',
                    url: '/timecarddoc',
                    component:
                        fromTimecard.TimeCardDocumentationFeatureComponent
                },
                {
                    name: 'timecard.doc',
                    url: '/doc',
                    component:
                        fromTimecard.TimeCardDocumentationFeatureComponent
                }
            ]
        })
    ]
})
export class TimeCardRoutingModule {}
